import { render } from "./form-dataset-material.vue?vue&type=template&id=076d45de"
import script from "./form-dataset-material.vue?vue&type=script&lang=js"
export * from "./form-dataset-material.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__